import { Spin } from 'antd';
import React from 'react';

type Props = {
    className?: string;
};

const Loader: React.FC<Props> = () => {
    return <Spin size="large" />;
};

export default Loader;
